import React from 'react';
import { AlertState, getAlertClassName, getAlertIconName } from '../../objects/facets/Alert';
import { has, is } from '../../services/classify';
import { Button } from '../button';
import { Icon, IconName, IconSize } from '../icon';
import { Text } from '../text';
import { Title, TitleLevels } from '../title';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Notification Component
 * @param hasIcon {boolean} Display icon, default true
 * @param iconName {IconName} Custom icon
 * @param title {string} Notification title content
 * @param description {string|ReactNode} Notification description content
 * @param alert {AlertState} Alert Variant (INFO|SUCCESS|WARNING|ERROR)
 * @param buttonClick {ClickEvent} Click event for button
 * @param buttonContent {string} Button content
 * @param arrow {boolean} Notification with right arrow on right side (Uses only if not button content)
 * @param info (boolean) Small info notification use it without button and arrow
 * @param onClick {Function} onClick Event for all notification
 * @param children {React.ReactNode}
 * @param closable {Function} onClick Event on cross icon
 *  * - -------------------------- WEB PROPERTIES -------------------------------
 * @param banner {boolean} Banner notification
 * @param className {string} Additionnal CSS Classes
 * @param iconClassname {string} Additionnal Icon CSS
 * @param buttonMarkup {ButtonMarkup} Custom markup for button
 *  * - -------------------------- NATIVE PROPERTIES -------------------------------
 * @param deletable {Function} onClick Event on delete icon or slide over ()
 * @param unread {boolean} only with notification deletable if notification is unread
 */
const Notification = ({ className, hasIcon = true, iconClassname, iconName, title, description, alert, buttonContent, buttonClick, buttonMarkup, arrow, info, banner, onClick, closable, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('notification', has('body'), !buttonContent && !arrow && info != null && is('small'), banner && !buttonContent && !arrow && !info && [is('banner'), !description && has('description')], description && has('description'), !!alert && (!info || (alert !== AlertState.INFO && info)) && is(getAlertClassName(alert)), className));
    const _iconNotif = React.useMemo(() => {
        var _a;
        if (iconName != null)
            return iconName;
        else if (info)
            return (_a = getAlertIconName(alert)) !== null && _a !== void 0 ? _a : IconName.INFOS_CIRCLE;
        else
            return IconName.BELL;
    }, [iconName, info, alert]);
    return (React.createElement("div", { "data-testid": testId, onClick: (e) => {
            // eslint-disable-next-line no-unused-expressions
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e.stopPropagation();
        }, className: classes, ...others },
        hasIcon && React.createElement(Icon, { className: iconClassname, name: _iconNotif }),
        React.createElement("div", { className: hashClass(styled, clsx('body')) },
            title && typeof title.valueOf() === 'string' ? React.createElement(Title, { level: TitleLevels.THREE }, title) : title,
            description && typeof description.valueOf() === 'string' ? React.createElement(Text, null, description) : description),
        buttonContent && !arrow && (React.createElement("div", { className: hashClass(styled, clsx('call-to-action')) },
            React.createElement(Button, { variant: 'PRIMARY', markup: buttonMarkup, onClick: buttonClick }, buttonContent))),
        arrow && !buttonContent && (React.createElement("div", { onClick: buttonClick, className: hashClass(styled, clsx('call-to-action')) },
            React.createElement(Icon, { name: IconName.ARROW_RIGHT, size: IconSize.SMALL }))),
        closable && !buttonContent && (React.createElement("div", { "data-testid": `${testId}_close_button`, role: 'button', onClick: closable, className: hashClass(styled, clsx('call-to-action')) },
            React.createElement(Icon, { name: IconName.TIMES, size: IconSize.SMALL })))));
};
export default Notification;
//# sourceMappingURL=Notification.js.map